import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import NotFound from '@/pages/GeneralViews/NotFoundPage'
import AuthLayout from '@/pages/Dashboard/Layout/AuthLayout'
import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout'

// Authehtification pages
import Login from '@/pages/Dashboard/Pages/Auth/Login'

// Dashboard page
import OrderIndex from '@/pages/Dashboard/Pages/Orders/Index'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/',
    component: AuthLayout,
    children: [
      {
        path: '/',
        name: 'Home Auth',
        component: Login
      }
    ]
  }, {
    path: '/cek-invoice',
    name: 'Dashboard',
    component: DashboardLayout,
    children: [
      {
        path: 'index',
        alias: '/',
        name: 'Cek Invoice',
        component: OrderIndex
      }
    ]
  }, {
    path: '*', component: NotFound
  }, {
    path: '404', component: NotFound
  }
]

Vue.use(VueRouter)
const router = new VueRouter({
  routes, // short for router: router
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['account/isLoggedIn']) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else if (to.meta.requiredAllowedRole !== undefined && to.meta.requiredAllowedRole.length > 0 && to.meta.requiredAllowedRole.filter(role => role === store.getters['account/accountData'].roles[0].name).length < 1) {
      next({
        path: '*'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => to.meta.requiresGuest)) {
    if (store.getters['account/isLoggedIn']) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js